module.exports = __webpack_public_path__ + "img/logo.5e514391.svg";